import { render, staticRenderFns } from "./Facturacion.vue?vue&type=template&id=0806254e&"
import script from "./Facturacion.vue?vue&type=script&lang=js&"
export * from "./Facturacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QToolbar,QToolbarTitle,QCard,QList,QItem,QItemSection,QItemLabel,QSeparator,QCardActions,QBtn,QTable,QTd} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QToolbar,QToolbarTitle,QCard,QList,QItem,QItemSection,QItemLabel,QSeparator,QCardActions,QBtn,QTable,QTd})
